import { operators as o, common as c } from '@pendo/aggregations';

export const top10FeaturesByVisitorsAgg: Array<c.PipelineData> = [
    {
        source: {
            features: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                appId: 'APP_ID',
            },
        },
    },
    o.evalExpression({
        featureId: 'id',
    }),
    {
        merge: {
            fields: ['appId'],
            mappings: {
                'app.id': 'id',
                'app.displayName': 'displayName',
                'app.platform': 'platform',
            },
            pipeline: [
                {
                    source: {
                        apps: null,
                    },
                },
                {
                    eval: {
                        appId: 'id',
                    },
                },
            ],
        },
    },
    {
        merge: {
            fields: ['featureId'],
            mappings: {
                numVisitors: 'numVisitors',
                numEvents: 'numEvents',
            },
            pipeline: [
                {
                    spawn: [
                        [
                            {
                                source: {
                                    featureEvents: {
                                        appId: 'APP_ID',
                                    },
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    timeSeries: 'DATE_RANGE',
                                },
                            },
                            {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                filters: ['SEGMENT_ID', 'ACCOUNT_ID'],
                            },
                            {
                                group: {
                                    group: ['featureId'],
                                    fields: [
                                        {
                                            numVisitors: {
                                                count: 'visitorId',
                                            },
                                        },
                                        {
                                            numEvents: {
                                                sum: 'numEvents',
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    ],
                },
                {
                    join: {
                        fields: ['featureId'],
                    },
                },
            ],
        },
    },
    o.evalExpression({
        numVisitors: 'if(isNil(numVisitors), 0, numVisitors)',
        numEvents: 'if(isNil(numEvents), 0, numEvents)',
    }),
    {
        sort: ['-numVisitors'],
    },
    o.limit(10),
    o.select({
        name: 'name',
        y: 'numVisitors',
        seriesName: 'name',
    }),
];

export const top10FeaturesByVisitorsAeuAgg: Array<c.PipelineData> = [
    {
        source: {
            features: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                appId: 'APP_ID',
            },
        },
    },
    o.evalExpression({
        featureId: 'id',
    }),
    {
        merge: {
            fields: ['appId'],
            mappings: {
                'app.id': 'id',
                'app.displayName': 'displayName',
                'app.platform': 'platform',
            },
            pipeline: [
                {
                    source: {
                        apps: null,
                    },
                },
                {
                    eval: {
                        appId: 'id',
                    },
                },
            ],
        },
    },
    {
        merge: {
            fields: ['featureId'],
            mappings: {
                numVisitors: 'numVisitors',
                numEvents: 'numEvents',
            },
            pipeline: [
                {
                    spawn: [
                        [
                            {
                                source: {
                                    featureEvents: {
                                        appId: 'APP_ID',
                                    },
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    timeSeries: 'DATE_RANGE',
                                },
                            },
                            {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                filters: ['SEGMENT_ID'],
                            },
                            {
                                group: {
                                    group: ['featureId'],
                                    fields: [
                                        {
                                            numVisitors: {
                                                count: 'visitorId',
                                            },
                                        },
                                        {
                                            numEvents: {
                                                sum: 'numEvents',
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    ],
                },
                {
                    join: {
                        fields: ['featureId'],
                    },
                },
            ],
        },
    },
    o.evalExpression({
        numVisitors: 'if(isNil(numVisitors), 0, numVisitors)',
        numEvents: 'if(isNil(numEvents), 0, numEvents)',
    }),
    {
        sort: ['-numVisitors'],
    },
    o.limit(10),
    o.select({
        name: 'name',
        y: 'numVisitors',
        seriesName: 'name',
    }),
];

export const top10FeaturesByEventsAgg: Array<c.PipelineData> = [
    {
        source: {
            features: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                appId: 'APP_ID',
            },
        },
    },
    o.evalExpression({
        featureId: 'id',
    }),
    {
        merge: {
            fields: ['appId'],
            mappings: {
                'app.id': 'id',
                'app.displayName': 'displayName',
                'app.platform': 'platform',
            },
            pipeline: [
                {
                    source: {
                        apps: null,
                    },
                },
                {
                    eval: {
                        appId: 'id',
                    },
                },
            ],
        },
    },
    {
        merge: {
            fields: ['featureId'],
            mappings: {
                numVisitors: 'numVisitors',
                numEvents: 'numEvents',
            },
            pipeline: [
                {
                    spawn: [
                        [
                            {
                                source: {
                                    featureEvents: {
                                        appId: 'APP_ID',
                                    },
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    timeSeries: 'DATE_RANGE',
                                },
                            },
                            {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                filters: ['SEGMENT_ID', 'ACCOUNT_ID'],
                            },
                            {
                                group: {
                                    group: ['featureId'],
                                    fields: [
                                        {
                                            numVisitors: {
                                                count: 'visitorId',
                                            },
                                        },
                                        {
                                            numEvents: {
                                                sum: 'numEvents',
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    ],
                },
                {
                    join: {
                        fields: ['featureId'],
                    },
                },
            ],
        },
    },
    o.evalExpression({
        numVisitors: 'if(isNil(numVisitors), 0, numVisitors)',
        numEvents: 'if(isNil(numEvents), 0, numEvents)',
    }),
    {
        sort: ['-numEvents'],
    },
    o.limit(10),
    o.select({
        name: 'name',
        y: 'numEvents',
        seriesName: 'name',
    }),
];

export const top10FeaturesByEventsAeuAgg: Array<c.PipelineData> = [
    {
        source: {
            features: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                appId: 'APP_ID',
            },
        },
    },
    o.evalExpression({
        featureId: 'id',
    }),
    {
        merge: {
            fields: ['appId'],
            mappings: {
                'app.id': 'id',
                'app.displayName': 'displayName',
                'app.platform': 'platform',
            },
            pipeline: [
                {
                    source: {
                        apps: null,
                    },
                },
                {
                    eval: {
                        appId: 'id',
                    },
                },
            ],
        },
    },
    {
        merge: {
            fields: ['featureId'],
            mappings: {
                numVisitors: 'numVisitors',
                numEvents: 'numEvents',
            },
            pipeline: [
                {
                    spawn: [
                        [
                            {
                                source: {
                                    featureEvents: {
                                        appId: 'APP_ID',
                                    },
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    timeSeries: 'DATE_RANGE',
                                },
                            },
                            {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                filters: ['SEGMENT_ID'],
                            },
                            {
                                group: {
                                    group: ['featureId'],
                                    fields: [
                                        {
                                            numVisitors: {
                                                count: 'visitorId',
                                            },
                                        },
                                        {
                                            numEvents: {
                                                sum: 'numEvents',
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    ],
                },
                {
                    join: {
                        fields: ['featureId'],
                    },
                },
            ],
        },
    },
    o.evalExpression({
        numVisitors: 'if(isNil(numVisitors), 0, numVisitors)',
        numEvents: 'if(isNil(numEvents), 0, numEvents)',
    }),
    {
        sort: ['-numEvents'],
    },
    o.limit(10),
    o.select({
        name: 'name',
        y: 'numEvents',
        seriesName: 'name',
    }),
];

export const top10PagesByVisitorsAgg: Array<c.PipelineData> = [
    {
        source: {
            pages: {
                appId: 'APP_ID',
            },
        },
    },
    {
        eval: {
            pageId: 'id',
        },
    },
    {
        merge: {
            fields: ['appId'],
            mappings: {
                'app.id': 'id',
                'app.displayName': 'displayName',
                'app.platform': 'platform',
            },
            pipeline: [
                {
                    source: {
                        apps: null,
                    },
                },
                {
                    eval: {
                        appId: 'id',
                    },
                },
            ],
        },
    },
    {
        merge: {
            fields: ['pageId'],
            mappings: {
                numVisitors: 'numVisitors',
                numEvents: 'numEvents',
            },
            pipeline: [
                {
                    spawn: [
                        [
                            {
                                source: {
                                    pageEvents: {
                                        appId: 'APP_ID',
                                    },
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    timeSeries: 'DATE_RANGE',
                                },
                            },
                            {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                filters: ['SEGMENT_ID', 'ACCOUNT_ID'],
                            },
                            {
                                group: {
                                    group: ['pageId'],
                                    fields: [
                                        {
                                            numVisitors: {
                                                count: 'visitorId',
                                            },
                                        },
                                        {
                                            numEvents: {
                                                sum: 'numEvents',
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    ],
                },
                {
                    join: {
                        fields: ['pageId'],
                    },
                },
            ],
        },
    },
    o.evalExpression({
        numVisitors: 'if(isNil(numVisitors), 0, numVisitors)',
        numEvents: 'if(isNil(numEvents), 0, numEvents)',
    }),
    {
        sort: ['-numVisitors'],
    },
    o.limit(10),
    o.select({
        name: 'name',
        y: 'numVisitors',
        seriesName: 'name',
    }),
];

export const top10PagesByVisitorsAeuAgg: Array<c.PipelineData> = [
    {
        source: {
            pages: {
                appId: 'APP_ID',
            },
        },
    },
    {
        eval: {
            pageId: 'id',
        },
    },
    {
        merge: {
            fields: ['appId'],
            mappings: {
                'app.id': 'id',
                'app.displayName': 'displayName',
                'app.platform': 'platform',
            },
            pipeline: [
                {
                    source: {
                        apps: null,
                    },
                },
                {
                    eval: {
                        appId: 'id',
                    },
                },
            ],
        },
    },
    {
        merge: {
            fields: ['pageId'],
            mappings: {
                numVisitors: 'numVisitors',
                numEvents: 'numEvents',
            },
            pipeline: [
                {
                    spawn: [
                        [
                            {
                                source: {
                                    pageEvents: {
                                        appId: 'APP_ID',
                                    },
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    timeSeries: 'DATE_RANGE',
                                },
                            },
                            {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                filters: ['SEGMENT_ID'],
                            },
                            {
                                group: {
                                    group: ['pageId'],
                                    fields: [
                                        {
                                            numVisitors: {
                                                count: 'visitorId',
                                            },
                                        },
                                        {
                                            numEvents: {
                                                sum: 'numEvents',
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    ],
                },
                {
                    join: {
                        fields: ['pageId'],
                    },
                },
            ],
        },
    },
    o.evalExpression({
        numVisitors: 'if(isNil(numVisitors), 0, numVisitors)',
        numEvents: 'if(isNil(numEvents), 0, numEvents)',
    }),
    {
        sort: ['-numVisitors'],
    },
    o.limit(10),
    o.select({
        name: 'name',
        y: 'numVisitors',
        seriesName: 'name',
    }),
];

export const top10PagesByEventsAgg: Array<c.PipelineData> = [
    {
        source: {
            pages: {
                appId: 'APP_ID',
            },
        },
    },
    {
        eval: {
            pageId: 'id',
        },
    },
    {
        merge: {
            fields: ['appId'],
            mappings: {
                'app.id': 'id',
                'app.displayName': 'displayName',
                'app.platform': 'platform',
            },
            pipeline: [
                {
                    source: {
                        apps: null,
                    },
                },
                {
                    eval: {
                        appId: 'id',
                    },
                },
            ],
        },
    },
    {
        merge: {
            fields: ['pageId'],
            mappings: {
                numVisitors: 'numVisitors',
                numEvents: 'numEvents',
            },
            pipeline: [
                {
                    spawn: [
                        [
                            {
                                source: {
                                    pageEvents: {
                                        appId: 'APP_ID',
                                    },
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    timeSeries: 'DATE_RANGE',
                                },
                            },
                            {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                filters: ['SEGMENT_ID', 'ACCOUNT_ID'],
                            },
                            {
                                group: {
                                    group: ['pageId'],
                                    fields: [
                                        {
                                            numVisitors: {
                                                count: 'visitorId',
                                            },
                                        },
                                        {
                                            numEvents: {
                                                sum: 'numEvents',
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    ],
                },
                {
                    join: {
                        fields: ['pageId'],
                    },
                },
            ],
        },
    },
    o.evalExpression({
        numVisitors: 'if(isNil(numVisitors), 0, numVisitors)',
        numEvents: 'if(isNil(numEvents), 0, numEvents)',
    }),
    {
        sort: ['-numEvents'],
    },
    o.limit(10),
    o.select({
        name: 'name',
        y: 'numEvents',
        seriesName: 'name',
    }),
];

export const top10PagesByEventsAeuAgg: Array<c.PipelineData> = [
    {
        source: {
            pages: {
                appId: 'APP_ID',
            },
        },
    },
    {
        eval: {
            pageId: 'id',
        },
    },
    {
        merge: {
            fields: ['appId'],
            mappings: {
                'app.id': 'id',
                'app.displayName': 'displayName',
                'app.platform': 'platform',
            },
            pipeline: [
                {
                    source: {
                        apps: null,
                    },
                },
                {
                    eval: {
                        appId: 'id',
                    },
                },
            ],
        },
    },
    {
        merge: {
            fields: ['pageId'],
            mappings: {
                numVisitors: 'numVisitors',
                numEvents: 'numEvents',
            },
            pipeline: [
                {
                    spawn: [
                        [
                            {
                                source: {
                                    pageEvents: {
                                        appId: 'APP_ID',
                                    },
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    timeSeries: 'DATE_RANGE',
                                },
                            },
                            {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                filters: ['SEGMENT_ID'],
                            },
                            {
                                group: {
                                    group: ['pageId'],
                                    fields: [
                                        {
                                            numVisitors: {
                                                count: 'visitorId',
                                            },
                                        },
                                        {
                                            numEvents: {
                                                sum: 'numEvents',
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    ],
                },
                {
                    join: {
                        fields: ['pageId'],
                    },
                },
            ],
        },
    },
    o.evalExpression({
        numVisitors: 'if(isNil(numVisitors), 0, numVisitors)',
        numEvents: 'if(isNil(numEvents), 0, numEvents)',
    }),
    {
        sort: ['-numEvents'],
    },
    o.limit(10),
    o.select({
        name: 'name',
        y: 'numEvents',
        seriesName: 'name',
    }),
];

export const averageDailyTimeOnAppAgg: Array<c.PipelineData> = [
    {
        source: {
            events: {
                appId: 'APP_ID',
            },
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            timeSeries: 'DATE_RANGE',
        },
    },
    {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        filters: ['SEGMENT_ID', 'ACCOUNT_ID'],
    },
    {
        group: {
            group: ['appId', 'day'],
            fields: [
                {
                    summedMinutes: {
                        sum: 'numMinutes',
                    },
                },
                {
                    visitors: {
                        count: 'visitorId',
                    },
                },
                {
                    visitorsByDay: {
                        count: ['visitorId', 'day'],
                    },
                },
            ],
        },
    },
    {
        eval: {
            averageTime: 'if(isNull(visitors) || visitors == 0, 0, summedMinutes / visitors)',
            visitors: 'if(isNull(visitors), 0, visitors)',
            averageDailyTimeOnApp: 'if(isNull(visitors) || visitors == 0, 0, summedMinutes / visitorsByDay)',
        },
    },
    {
        merge: {
            fields: ['appId'],
            mappings: {
                appName: 'appName',
            },
            pipeline: [
                {
                    source: {
                        apps: null,
                    },
                },
                {
                    select: {
                        appId: 'id',
                        appName: 'displayName + " - " + platform',
                    },
                },
            ],
        },
    },
    {
        select: {
            seriesName: 'appName',
            averageTime: 'averageTime',
            y: 'averageDailyTimeOnApp',
            summedMinutes: 'summedMinutes',
            visitors: 'visitors',
            x: 'day',
        },
    },
];

export const averageDailyTimeOnAppAeuAgg: Array<c.PipelineData> = [
    {
        source: {
            events: {
                appId: 'APP_ID',
            },
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            timeSeries: 'DATE_RANGE',
        },
    },
    {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        filters: ['SEGMENT_ID'],
    },
    {
        group: {
            group: ['appId', 'day'],
            fields: [
                {
                    summedMinutes: {
                        sum: 'numMinutes',
                    },
                },
                {
                    visitors: {
                        count: 'visitorId',
                    },
                },
                {
                    visitorsByDay: {
                        count: ['visitorId', 'day'],
                    },
                },
            ],
        },
    },
    {
        eval: {
            averageTime: 'if(isNull(visitors) || visitors == 0, 0, summedMinutes / visitors)',
            visitors: 'if(isNull(visitors), 0, visitors)',
            averageDailyTimeOnApp: 'if(isNull(visitors) || visitors == 0, 0, summedMinutes / visitorsByDay)',
        },
    },
    {
        merge: {
            fields: ['appId'],
            mappings: {
                appName: 'appName',
            },
            pipeline: [
                {
                    source: {
                        apps: null,
                    },
                },
                {
                    select: {
                        appId: 'id',
                        appName: 'displayName + " - " + platform',
                    },
                },
            ],
        },
    },
    {
        select: {
            seriesName: 'appName',
            averageTime: 'averageTime',
            y: 'averageDailyTimeOnApp',
            summedMinutes: 'summedMinutes',
            visitors: 'visitors',
            x: 'day',
        },
    },
];

export const averageWeeklyTimeOnAppAgg: Array<c.PipelineData> = [
    {
        source: {
            events: {
                appId: 'APP_ID',
            },
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            timeSeries: 'DATE_RANGE',
        },
    },
    {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        filters: ['SEGMENT_ID', 'ACCOUNT_ID'],
    },
    {
        group: {
            group: ['appId', 'week'],
            fields: [
                {
                    summedMinutes: {
                        sum: 'numMinutes',
                    },
                },
                {
                    visitors: {
                        count: 'visitorId',
                    },
                },
                {
                    visitorsByWeek: {
                        count: ['visitorId', 'week'],
                    },
                },
            ],
        },
    },
    {
        eval: {
            averageTime: 'if(isNull(visitors) || visitors == 0, 0, summedMinutes / visitors)',
            visitors: 'if(isNull(visitors), 0, visitors)',
            averageWeeklyTimeOnApp: 'if(isNull(visitors) || visitors == 0, 0, summedMinutes / visitorsByWeek)',
        },
    },
    {
        merge: {
            fields: ['appId'],
            mappings: {
                appName: 'appName',
            },
            pipeline: [
                {
                    source: {
                        apps: null,
                    },
                },
                {
                    select: {
                        appId: 'id',
                        appName: 'displayName + " - " + platform',
                    },
                },
            ],
        },
    },
    {
        select: {
            seriesName: 'appName',
            averageTime: 'averageTime',
            y: 'averageWeeklyTimeOnApp',
            summedMinutes: 'summedMinutes',
            visitors: 'visitors',
            x: 'week',
        },
    },
];

export const averageWeeklyTimeOnAppAeuAgg: Array<c.PipelineData> = [
    {
        source: {
            events: {
                appId: 'APP_ID',
            },
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            timeSeries: 'DATE_RANGE',
        },
    },
    {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        filters: ['SEGMENT_ID'],
    },
    {
        group: {
            group: ['appId', 'week'],
            fields: [
                {
                    summedMinutes: {
                        sum: 'numMinutes',
                    },
                },
                {
                    visitors: {
                        count: 'visitorId',
                    },
                },
                {
                    visitorsByWeek: {
                        count: ['visitorId', 'week'],
                    },
                },
            ],
        },
    },
    {
        eval: {
            averageTime: 'if(isNull(visitors) || visitors == 0, 0, summedMinutes / visitors)',
            visitors: 'if(isNull(visitors), 0, visitors)',
            averageWeeklyTimeOnApp: 'if(isNull(visitors) || visitors == 0, 0, summedMinutes / visitorsByWeek)',
        },
    },
    {
        merge: {
            fields: ['appId'],
            mappings: {
                appName: 'appName',
            },
            pipeline: [
                {
                    source: {
                        apps: null,
                    },
                },
                {
                    select: {
                        appId: 'id',
                        appName: 'displayName + " - " + platform',
                    },
                },
            ],
        },
    },
    {
        select: {
            seriesName: 'appName',
            averageTime: 'averageTime',
            y: 'averageWeeklyTimeOnApp',
            summedMinutes: 'summedMinutes',
            visitors: 'visitors',
            x: 'week',
        },
    },
];
